import axios from "../api/axios";
import useAuth from "./useAuth";

const useRefreshToken = () => {
  const { setFirmAuth, setPersonnelAuth, firmAuth, personnelAuth } = useAuth();

  const refresh = async () => {
    // Determine which auth state and endpoint to use
    let endpoint;
    let currentAuth;

    if (firmAuth?.refreshToken) {
      endpoint = "/firm/auth/refreshTokenWeb";
      currentAuth = firmAuth;
    } else if (personnelAuth?.refreshToken) {
      endpoint = "/personnel/auth/refreshTokenWeb";
      currentAuth = personnelAuth;
    } else {
      // No refresh token available
      return null;
    }

    try {
      const response = await axios.get(endpoint, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${currentAuth.refreshToken}`,
        },
      });

      const newAuthData = {
        user: response.data.user,
        accessToken: response.data.accessToken,
        refreshToken: response.data.refreshToken, // If your API returns a new refresh token
      };

      // Update the appropriate auth state based on which endpoint was used
      if (endpoint.includes("firm")) {
        setFirmAuth(newAuthData);
      } else {
        setPersonnelAuth(newAuthData);
      }

      return response.data.accessToken;
    } catch (error) {
      // Clear the appropriate auth state if refresh fails
      if (endpoint.includes("firm")) {
        setFirmAuth(null);
      } else {
        setPersonnelAuth(null);
      }
      throw error;
    }
  };

  return refresh;
};
export default useRefreshToken;
